// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ecMd","textarea":"styles_textarea__2cojr"};